/* global System window */

const trimSlash = str => str && str.replace(/(.*)^\/$/, '$1');

const isWidget = name => name.indexOf('widget-') === 0;
const isContainer = name => name.indexOf('container-') === 0;

const itemType = (name) => {
  if (isWidget(name)) {
    return 'widgets';
  }
  return (isContainer(name)) ? 'containers' : 'features';
};

const PROTOCOL_REGEX = /^[A-z][A-z0-9+.-]+:\/\//;
const isAbsolutePath = (name) => name.indexOf('/') === 0 || (PROTOCOL_REGEX.test(name));

const isCx5 = (version) => version === '5';

export {
  isAbsolutePath,
  isCx5,
  itemType,
  trimSlash,
};



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/util.js